module.exports = __webpack_public_path__ + "static/media/charity-gray.a3c688b5.webp";